module.exports = __webpack_public_path__ + "img/clogo.5febe3fa.png";